export default __webpack_public_path__ + "static/media/TargetingIcon_Dark.f843db81.svg";